export const EnvKeySelf = "$self";
export const EnvKeyChain = "$chain";
export const EnvKeyWalletID = "$wallet";
export const EnvKeyABI = "$abi";
export const EnvKeyValue = "$value";
export const EnvKeyValidity = "$validity";
export const EnvKeySlippage = "$slippage";

export const EnvKeyOKPage = "@instance";

export const EnvKeyMissingKeys = "@missing";

// logs
export const EnvKeyPrettyLogs = "@plog";
export const EnvKeyRawLogs = "@rlog";
export const EnvKeyAnalyzedLogs = "@anlog";
export const EnvKeyStepLogs = "@slog";

export const EnvKeyPivot = "@pivot";

export const EnvKeyCurrentAllowance = "@currentAllowance";
export const EnvKeyWantedAllowance = "@wantedAllowance";
export const EnvKeyAllowanceSpender = "@allowanceSpender";
